import { Skeleton, type Theme, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { Content, PrimaryContent, SkeletonContainer, SupportingContent } from './styled.ts';

const skeletonTextSx = {
  fontSize: '0.875rem',
};

export type TileSkeletonProps = {
  imageType?: 'poster' | 'backdrop';
  orientation: 'horizontal' | 'vertical';
  sx?: SystemStyleObject<Theme>;
};

export const TileSkeleton = ({ imageType = 'poster', orientation = 'vertical', sx }: TileSkeletonProps) => {
  const theme = useTheme();
  const isVertical = orientation === 'vertical';

  return (
    <SkeletonContainer
      sx={{
        [theme.breakpoints.down('md')]: {
          height: isVertical ? '100%' : '150px',
        },
        flexDirection: isVertical ? 'column' : 'row',
        height: isVertical ? '100%' : '188px',
        ...sx,
      }}
    >
      <Skeleton
        sx={{
          [theme.breakpoints.down('md')]: {
            paddingRight: isVertical ? undefined : '100px',
          },
          borderRadius: '8px',
          height: isVertical ? 0 : '100%',
          marginRight: isVertical ? undefined : theme.spacing(2),
          paddingBottom: isVertical ? (imageType === 'backdrop' ? '56%' : '150%') : undefined,
          paddingRight: isVertical ? undefined : '125px',
          width: isVertical ? '100%' : 0,
        }}
        variant="rectangular"
      />
      <Content sx={{ justifyContent: isVertical ? undefined : 'space-between' }}>
        <PrimaryContent>
          <Skeleton sx={skeletonTextSx} variant="text" />
          <Skeleton sx={skeletonTextSx} variant="text" />
          {isVertical ? undefined : <Skeleton sx={skeletonTextSx} variant="text" width="50%" />}
        </PrimaryContent>
        <SupportingContent>
          <Skeleton sx={skeletonTextSx} variant="text" width="20%" />
          <Skeleton sx={skeletonTextSx} variant="text" width="5%" />
        </SupportingContent>
      </Content>
    </SkeletonContainer>
  );
};
